import mitt from "mitt"

export let Emitter = mitt()

export default Emitter
